import { useEffect, useRef, useCallback } from 'react';
import { useSelector } from 'react-redux';
const {REACT_APP_WS_URL} = process.env;

const useWebSocket = () => {
  const wsRef = useRef(null);
  const user = useSelector((state) => state.user?.userData);
  const token = localStorage.getItem('token');
    
  const connectWebSocket = useCallback(() => {
    if (!user?.userId || !token) return;

    const wsUrl = REACT_APP_WS_URL;
    
    try {

      wsRef.current = new WebSocket(`${wsUrl}?token=${token}`);

      wsRef.current.onopen = () => {
        console.log('WebSocket: Connessione stabilita');
      };

      wsRef.current.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          
          switch (data.type) {
            case 'contenuti_status_update':
              handleContenutiStatusUpdate(data.contenuti);
              break;
            default:
              console.log('WebSocket: Tipo messaggio sconosciuto:', data.type);
          }
        } catch (error) {
          console.error('WebSocket: Errore parsing messaggio:', error);
        }
      };

      wsRef.current.onerror = (error) => {
        console.error('WebSocket: Errore connessione:', error);
      };

      wsRef.current.onclose = (event) => {
        console.log('WebSocket: Connessione chiusa. Codice:', event.code, 'Motivo:', event.reason);
        setTimeout(connectWebSocket, 5000);
      };

    } catch (error) {
      console.error('WebSocket: Errore durante la creazione della connessione:', error);
    }
  }, [user?.userId, token]);

  const checkContentStatus = useCallback((idClasse) => {
    if (wsRef.current?.readyState === WebSocket.OPEN) {
      const message = {
        type: 'check_contenuti_status',
        user_id: user?.userId,
        id_classe: idClasse,
        token: token
      };
      wsRef.current.send(JSON.stringify(message));
    } else {
      console.log('WebSocket: Non pronto. Stato:', wsRef.current?.readyState);
    }
  }, [user?.userId, token]);

  const handleContenutiStatusUpdate = useCallback((contenuti) => {
    if (!contenuti?.length) return;
    
    const event = new CustomEvent('contenutiStatusUpdate', { 
      detail: { contenuti } 
    });
    window.dispatchEvent(event);
    
  }, []);

  useEffect(() => {
    connectWebSocket();
    return () => {
      if (wsRef.current) {
        wsRef.current.close();
      }
    };
  }, [connectWebSocket]);

  return {
    checkContentStatus,
    isConnected: wsRef.current?.readyState === WebSocket.OPEN
  };
};

export default useWebSocket;